var _path, _path2, _g, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyHighlights(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 127,
    viewBox: "0 0 127 127",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.4551 126C97.948 126 125.91 98.0178 125.91 63.5C125.91 28.9822 97.948 1 63.4551 1C28.9621 1 1 28.9822 1 63.5C1 98.0178 28.9621 126 63.4551 126Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_878",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 127,
    height: 127
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4551 126C97.948 126 125.91 98.0178 125.91 63.5C125.91 28.9822 97.948 1 63.4551 1C28.9621 1 1 28.9822 1 63.5C1 98.0178 28.9621 126 63.4551 126Z",
    fill: "#F1F3F9",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_878)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M97.6689 52.0271L98.7311 126.392C98.7311 128.841 96.8191 130.845 94.2698 130.845H25.0135C22.6767 130.845 20.5522 128.841 20.5522 126.392V30.8755C20.5522 28.4263 22.4642 26.4225 25.0135 26.4225H75.15L97.6689 52.0271Z",
    fill: "#D6DCE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.805 46.5559L107.93 121.74C107.93 124.216 105.905 126.242 103.206 126.242H29.8751C27.4008 126.242 25.1514 124.216 25.1514 121.74V25.1711C25.1514 22.695 27.1758 20.6691 29.8751 20.6691H82.9612L106.805 46.5559Z",
    fill: "white",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9614 20.6691V41.3785C82.9614 44.3048 85.4358 46.5559 88.36 46.5559H106.805",
    fill: "#D6DCE8"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4551 126C97.948 126 125.91 98.0178 125.91 63.5C125.91 28.9822 97.948 1 63.4551 1C28.9621 1 1 28.9822 1 63.5C1 98.0178 28.9621 126 63.4551 126Z",
    stroke: "#D6DCE8",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.553 27.5308L116.939 26.9145C117.401 26.7604 117.401 26.1441 116.939 25.9901L115.553 25.3738C113.859 24.6034 112.474 23.2167 111.704 21.5219L111.088 20.1352C110.934 19.673 110.318 19.673 110.164 20.1352L109.548 21.5219C108.779 23.2167 107.393 24.6034 105.699 25.3738L104.314 25.9901C103.852 26.1441 103.852 26.7604 104.314 26.9145L105.699 27.5308C107.393 28.3012 108.779 29.6878 109.548 31.3826L110.164 32.7693C110.318 33.2315 110.934 33.2315 111.088 32.7693L111.704 31.3826C112.32 29.6878 113.705 28.3012 115.553 27.5308Z",
    fill: "#AAB2C5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.619 18.7485L101.543 18.2863C101.851 18.1322 101.851 17.8241 101.543 17.67L100.619 17.3618C99.3871 16.8996 98.4633 15.9752 98.0014 14.7426L97.5395 13.8181C97.3856 13.51 97.0777 13.51 96.9237 13.8181L96.6158 14.7426C95.9999 15.9752 95.0761 16.8996 93.9984 17.3618L92.9206 17.8241C92.7667 17.8241 92.7667 18.2863 92.9206 18.2863L93.8444 18.7485C95.0761 19.2107 95.9999 20.1352 96.6158 21.3678L97.0777 22.2922C97.2316 22.6004 97.5395 22.6004 97.6935 22.2922L98.0014 21.3678C98.4633 20.1352 99.3871 19.2107 100.619 18.7485Z",
    fill: "#AAB2C5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M112.473 9.81238L113.243 9.50423C113.397 9.35015 113.397 9.19608 113.243 9.04201L112.473 8.73386C111.55 8.42571 110.934 7.65534 110.472 6.7309L110.164 5.96053C110.01 5.80645 109.856 5.80645 109.702 5.96053L109.394 6.7309C109.086 7.65534 108.316 8.27164 107.393 8.73386L106.931 9.04201C106.623 9.19608 106.623 9.50423 106.931 9.50423L107.7 9.81238C108.624 10.1205 109.24 10.8909 109.702 11.8153L110.01 12.5857C110.164 12.7398 110.318 12.7398 110.472 12.5857L110.78 11.8153C110.934 10.8909 111.704 10.1205 112.473 9.81238Z",
    fill: "#AAB2C5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyHighlights);
export default __webpack_public_path__ + "static/media/EmptyHighlights.4cfa2b705d97832a1ab790259b905bae.svg";
export { ForwardRef as ReactComponent };